import api from './api';

export interface DashboardStats {
  total_funds: number;
  active_alerts: number;
  recent_regulatory_updates: number;
  high_risk_funds: number;
  last_updated: string;
}

export interface ActivityItem {
  id: string;
  type: 'alert' | 'regulatory';
  title: string;
  description: string;
  severity: string;
  created_at: string;
  icon: string;
}

export interface Alert {
  id: string;
  title: string;
  description: string;
  severity: string;
  created_at: string;
  is_read?: boolean;
  fund_id?: string;
  user_id?: string;
}

export interface Fund {
  id: string;
  name: string;
  aum: number;
  status: string;
  risk_level: string;
  created_at: string;
}

export interface RegulatoryUpdate {
  id: string;
  title: string;
  description: string;
  impact_level: string;
  source: string;
  created_at: string;
  effective_date?: string;
}

export interface FundNetworkData {
  nodes: Array<{
    id: string;
    label: string;
    type: 'fund' | 'service_provider';
    aum?: number;
    risk_level?: string;
    category?: string;
  }>;
  edges: Array<{
    from: string;
    to: string;
    relationship: string;
  }>;
  total_funds: number;
  total_providers: number;
}

class DashboardService {
  async getStats(): Promise<DashboardStats> {
    const response = await api.get('/dashboard/stats');
    return response.data;
  }

  async getRecentActivity(limit: number = 10): Promise<ActivityItem[]> {
    const response = await api.get(`/dashboard/recent-activity?limit=${limit}`);
    return response.data;
  }

  async getAlerts(limit: number = 10): Promise<Alert[]> {
    const response = await api.get(`/dashboard/alerts?limit=${limit}`);
    return response.data;
  }

  async getTopFunds(limit: number = 10): Promise<Fund[]> {
    const response = await api.get(`/dashboard/top-funds?limit=${limit}`);
    return response.data;
  }

  async getRegulatoryUpdates(limit: number = 10): Promise<RegulatoryUpdate[]> {
    const response = await api.get(`/dashboard/regulatory-updates?limit=${limit}`);
    return response.data;
  }

  async getFundNetworkData(limit: number = 50): Promise<FundNetworkData> {
    const response = await api.get(`/dashboard/fund-network?limit=${limit}`);
    return response.data;
  }

  async createSampleData(): Promise<{ message: string; status: string }> {
    const response = await api.post('/dashboard/create-sample-data');
    return response.data;
  }
}

export const dashboardService = new DashboardService();
